import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import type { DocumentLink } from "web_myplann/Portfolio/Types/documentLink";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

const DETAIL_PATHS: Record<PortfolioItemKind, (id: string) => string> = {
	[PortfolioItemKind.Portfolio]: (id) =>
		Routing.Portfolio.PortfolioDetail.path(id),
	[PortfolioItemKind.Property]: (id) =>
		Routing.Portfolio.PropertyDetail.path(id),
};

export const documentLinkDetailPath = (link: DocumentLink): string =>
	DETAIL_PATHS[link.kind](link.id.toString());
